module.exports = __webpack_public_path__ + "img/jennifer-gillan.cd82feb9.jpg";